import React from 'react';
import '../styles/pages.css';

const TermsOfService = () => {
  return (
    <div className="terms-of-service-page container" style={{ marginTop: '2rem', marginBottom: '4rem' }}>
      <section className="page-hero">
        <div className="page-hero-content">
          <h1>Terms of Service</h1>
          <p className="hero-subtitle">
            Please read these Terms of Service carefully before using the Vedic Surgery platform.
          </p>
        </div>
      </section>

      <div className="content-card" style={{ marginTop: '2rem' }}>
        <div className="intro-content">
          <p className="lead">
            Welcome to the Vedic Surgery Project. By accessing or using our platform, you agree to comply with and be bound by the following terms and conditions.
          </p>
          
          <hr style={{ border: 'none', borderBottom: '1px solid var(--border-color)', margin: '2rem 0' }} />

          <h2>1. Acceptance of Terms</h2>
          <p>
            By creating an account, registering on our platform, or accessing any educational resources on Vedic Surgery, you agree to these Terms of Service, our Privacy Policy, and any other guidelines posted on our site.
          </p>

          <h2>2. Educational Purpose</h2>
          <p>
            The Vedic Surgery platform is designed purely for educational, academic, and research purposes. All content, simulations, AI reader recommendations, and translation tools are provided to help users understand Shalya Tantra (classical Ayurvedic surgery) and modern surgical sciences. They do not constitute professional medical advice, diagnosis, or treatment.
          </p>

          <h2>3. User Registration and Account Security</h2>
          <p>
            To access certain features of the platform, you must register and create a user profile. You agree to:
          </p>
          <ul style={{ paddingLeft: '1.5rem', marginBottom: '1.5rem', listStyleType: 'disc' }}>
            <li style={{ marginBottom: '0.5rem', color: 'var(--text-secondary)' }}>Provide accurate, current, and complete information.</li>
            <li style={{ marginBottom: '0.5rem', color: 'var(--text-secondary)' }}>Maintain the confidentiality of your account credentials.</li>
            <li style={{ marginBottom: '0.5rem', color: 'var(--text-secondary)' }}>Accept responsibility for all activities occurring under your account.</li>
          </ul>

          <h2>4. Permitted Use & Upload Limits</h2>
          <p>
            Users are permitted to upload profile photos, interact in workshops, and use Prakriti evaluations. File uploads for user profile images are strictly limited to a maximum file size of <strong>1 MB</strong> to ensure optimal performance and security. Any upload exceeding this limit will be rejected by our servers.
          </p>

          <h2>5. Intellectual Property</h2>
          <p>
            The contents, logos, text, research papers, translation structures, and platform designs are the intellectual property of the Vedic Surgery Project or its respective contributors. Unauthorized duplication, modification, or redistribution of copyrighted materials is strictly prohibited.
          </p>

          <h2>6. Soft Deletion Policy</h2>
          <p>
            In order to preserve database integrity and audit logs, when you deactivate or delete your account, we perform a soft deletion. This means your record's active status is set to inactive, and your personal data is restricted from public display but retained securely in compliance with our platform archiving policies.
          </p>

          <h2>7. Contact Us</h2>
          <p>
            For any queries or concerns regarding these Terms, please reach out to us at <strong style={{ color: 'var(--primary-color)' }}>vedicsurgery@gmail.com</strong>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
